export default "__VITE_ASSET__DD6SOlDg__"